import { stringToSVG } from '../../../utilities';

const svg = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_spreadsheet_file)">
<path d="M27.5 5V10H32.5" stroke="black" stroke-width="1.5"/>
<path d="M32.5 10L27.5 5H7.5V35H32.5V10Z" stroke="#2E3138" stroke-width="1.5"/>
<rect x="11.5" y="14" width="17" height="16" stroke="#2E3138" stroke-width="1.5"/>
<path d="M20 14V30" stroke="#2E3138" stroke-width="1.5"/>
<path d="M11.5 19.3333H28.5" stroke="#2E3138" stroke-width="1.5"/>
<path d="M11.5 24.6667H28.5" stroke="#2E3138" stroke-width="1.5"/>
</g>
<defs>
<clipPath id="clip0_spreadsheet_file">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`;

export default stringToSVG(svg);
